@if (handelssortiment) {
  <rask-container-block>
    <ng-container header>
      <rask-header size="2" underline>
        {{ 'TPL_DESTINERA_HEADER' | translate }}
        @if (arbetsorders) {
          <span class="small-text">{{ nrOfSelectedAos }} av {{ arbetsorders.length }}
          valda</span>
        }
        <rask-button color="primary" [disabled]="!canDestinera || !canEdit" (click)="openDialog()"
          class="destinerabtn">
        {{ 'TPL_DESTINERA_BUTTON' | translate }}</rask-button>
      </rask-header>
    </ng-container>
    <div class="row row-top">
      <rask-selector
        aid="inputHandelssortiment"
        class="col-8"
        label="{{ 'TPL_FILTER_HANDELSSORTIMENT' | translate }}"
        [viewFormatter]="outputformatter"
        [formatter]="formatter"
        [values]="handelssortiment"
        [(ngModel)]="selectedHandelssortiment"
        (change)="selectHandelssortiment($event)">
      </rask-selector>
      <div class="info-container col-4">
        <rask-checkbox
          aid="checkAll"
          [(ngModel)]="allSelected"
          text="{{ 'TPL_LIST_SELECT_ALL' | translate }}"
          (checkedChange)="onAllSelectedChanged($event)"
        class="allCheckBox"></rask-checkbox>
      </div>
    </div>
    <div class="list-container">
      @for (arbetsorder of arbetsorders; track arbetsorder) {
        <div>
            <div class="row row-border" [ngClass]="{
                                                    'red-back' : arbetsorder.warningVisible,
                                                    'ao-row-hover' : arbetsorder.hover,
                                                    'error-back': arbetsorder?.warnings[0]?.type === 'error' && arbetsorder.warningVisible,
                                                    'ao-row-hover-error' : arbetsorder.hover && arbetsorder?.warnings[0]?.type === 'error'
                                                }"
            (click)="arbetsorder.warningVisible && showWarningInfo(arbetsorder.id)"
            (mouseover)="mouseOver(arbetsorder.id)"
            (mouseout)="mouseOut(arbetsorder.id)">
            <div class="col-10">
              @if (!arbetsorder.isDelad) {
                <div
                  [ngClass]="{'square': arbetsorder.isTerminalImport, 'dot': !arbetsorder.isTerminalImport, 'destinerad': arbetsorder.isDestinerad, 'ejdestinerad': !arbetsorder.isDestinerad}">
                </div>
              }
              @if (arbetsorder.isDelad && !arbetsorder.isTerminalImport) {
                <div class="halfdestinerad"><i class="fad fa-adjust"></i>
              </div>
            }
            @if (arbetsorder.isDelad && arbetsorder.isTerminalImport) {
              <div class="triangle">
              </div>
            }
            <a href="" (click)="aoDetails($event, arbetsorder.id)">
              {{ arbetsorder.beteckning }} {{ arbetsorder.namn }}
            </a>
            @if (arbetsorder.handelssortimentInfo?.hasInaktivaDestineringar) {
              <rask-info
                [infoIconSolid]="false"
                class="infoIcon">
                Arbetsordern innehåller begränsade rader för valt handelssortiment
              </rask-info>
            }
            @for (warning of arbetsorder?.warnings; track warning) {
              <span class="icon">
                <i class="fal"
                  [ngClass]="{'info fa-info-circle': warning.type === 'info', 'warning fa-exclamation-square': warning.type === 'warning', 'error fa-exclamation-circle':  warning.type === 'error' }"
                  placement="bottom"
                  [ngbTooltip]="warning.brief">
                </i>
              </span>
            }
          </div>
          <div class="col-2">
            <rask-checkbox
              (checkedChange)="onCheckedChanged($event)"
              class="checkbox low"
              [(ngModel)]="arbetsorder.isSelected">
            </rask-checkbox>
          </div>
          @if (showDetails && arbetsorder.handelssortimentInfo !== null && arbetsorder.handelssortimentInfo !== undefined) {
            <div
              >
              <div class="newLine small-text details-padding" style="width: 400px;">
                <div class="d-inline-block w-50">{{ arbetsorder.handelssortimentInfo.handelssortimentNamn }}
                </div>
                <div class="d-inline-block">
                  {{ arbetsorder.handelssortimentInfo.planeradVolym }}/{{ arbetsorder.handelssortimentInfo.vagVolym }}
                  {{ 'TPL_DESTINERA_M3FUB' | translate }}
                </div>
              </div>
              @for (dest of arbetsorder.handelssortimentInfo.destineringar; track dest) {
                <div
                  class="newLine small-text details-padding" style="width: 400px;">
                  <div class="d-inline-block w-50">{{ dest.namn }}</div>
                  <div class="d-inline-block w-50">{{ dest.andelProcent }}%</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
  <ng-container footer></ng-container>
</rask-container-block>
}
